export default Object.freeze({
  Pending: 1,
  Running: 2,
  Completed: 3,
  Canceled: 4,
  Inactive: 5,
  Active: 6,
  Failed: 7,
  CanceledByUser: 8
});
